import { IAnyStateTreeNode, ISerializedActionCall, onAction } from 'mobx-state-tree';
import { useEffect } from 'react';

interface UseOnActionArgs {
  target: IAnyStateTreeNode;
  cb: (call: ISerializedActionCall) => void;
}
export const useOnAction = ({target, cb}: UseOnActionArgs) => {
  useEffect(() => {
    const disposer = onAction(target, call => {
      cb(call);
    });
    return () => {
      disposer();
    };
  }, [target, cb]);
};
